import React from "react";
import Card from "components/card";
import Chart from "react-apexcharts";

const CrawlerActivityChart = ({ rows }) => {
  const dailyData = React.useMemo(() => {
    const map = {};
    (rows || []).forEach((row) => {
      if (!row?.runDate) return;
      const dateStr = row.runDate.slice(0, 10);
      if (!map[dateStr]) map[dateStr] = 0;
      map[dateStr]++;
    });
    return Object.entries(map)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([date, count]) => ({ date, count }));
  }, [rows]);

  if (dailyData.length === 0) {
    return (
      <Card extra="p-5">
        <h4 className="text-base font-bold text-navy-700 dark:text-white mb-4 font-dm">
          Crawl Activity Over Time
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400 text-sm">No data available</p>
        </div>
      </Card>
    );
  }

  return (
    <Card extra="p-5">
      <h4 className="text-base font-bold text-navy-700 dark:text-white mb-1 font-dm">
        Crawl Activity Over Time
      </h4>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 font-dm">
        Retailers scanned per day
      </p>
      <Chart
        type="area"
        height={300}
        series={[{ name: "Crawls", data: dailyData.map((d) => d.count) }]}
        options={{
          chart: {
            type: "area",
            toolbar: { show: false },
            fontFamily: "DM Sans, sans-serif",
            zoom: { enabled: false },
          },
          colors: ["#4f46e5"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [0, 100],
            },
          },
          stroke: { curve: "smooth", width: 2.5 },
          dataLabels: { enabled: false },
          xaxis: {
            categories: dailyData.map((d) => d.date),
            labels: {
              rotate: -45,
              rotateAlways: dailyData.length > 10,
              style: { fontSize: "10px", fontFamily: "DM Sans, sans-serif" },
            },
            tickAmount: Math.min(dailyData.length, 12),
          },
          yaxis: {
            title: { text: "Crawls", style: { fontFamily: "DM Sans, sans-serif", fontSize: "12px" } },
            labels: { style: { fontSize: "11px" } },
          },
          grid: {
            borderColor: "#e5e7eb",
            strokeDashArray: 4,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
          },
          tooltip: { theme: "dark", x: { show: true } },
        }}
      />
    </Card>
  );
};

export default CrawlerActivityChart;
